/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';

import { withMsal } from '@azure/msal-react';
// import EditIcon from '@mui/icons-material/Edit';
import {
  Container,
  Grid,
  Typography,
  // Button,
  Divider,
  // TextField,
  // Badge,
  Avatar,
  // Stack,
  Box,
  // OutlinedInput,
} from '@mui/material';
import { deepPurple } from '@mui/material/colors';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Breadcrumbs } from 'wae_rwlb_reactlibrary';

import {
  logUserOut,
  handleSalesOrgDialog,
  loadCustomerMasterData,
  getShipToPartyData,
} from '../../actions/index';
import { COLOR } from '../../helpers/colors';
import { breadcrumbNameMap } from '../../helpers/config';
import { getAvatarText } from '../../helpers/functions';

const Info = t => [
  {
    title: t('profileScreenTranslations:GEN_INFO'),
    data: [
      {
        label: t('profileScreenTranslations:EMAIL'),
        value: 'EmailAddress',
      },
      {
        label: t('profileScreenTranslations:PHONE_NUM'),
        value: 'PhoneNumber',
      },
      {
        label: t('profileScreenTranslations:ADDRESS'),
        value: 'StreetName',
      },
      { label: t('profileScreenTranslations:COUNTRY'), value: 'Country' },
      { label: t('profileScreenTranslations:CITY'), value: 'CityName' },
      {
        label: t('profileScreenTranslations:ZIP_CODE'),
        value: 'PostalCode',
      },
    ],
  },
  {
    title: 'Dealership Information',
    data: [
      {
        label: 'Business Partner',
        value: 'BusinessPartner',
      },
      {
        label: 'Name',
        value: 'BusinessPartnerName',
      },
    ],
  },
  {
    title: t('profileScreenTranslations:SALES_AREA_INFO'),
    data: [
      {
        label: t('profileScreenTranslations:SALES_ORGANIZATION'),
        value: 'SalesOrg',
      },
      {
        label: t('profileScreenTranslations:DISTRIBUTION_CHANNEL'),
        value: 'DisCha',
      },
      {
        label: t('profileScreenTranslations:DIVISION'),
        value: 'Division',
      },
    ],
  },
  {
    title: t('profileScreenTranslations:CREDIT_INFORMATION'),
    data: [
      {
        label: t('profileScreenTranslations:CREDIT_SEGMENT'),
        value: 'CreditSegment',
      },
      {
        label: t('profileScreenTranslations:CREDIT_BLOCK'),
        value: 'CreditBlock',
      },
      {
        label: t('profileScreenTranslations:CREDIT_LIMIT'),
        value: 'CreditLimit',
      },
      {
        label: t('profileScreenTranslations:AVAILABLE_CREDIT'),
        value: 'AvailableCredit',
      },
    ],
  },
];
class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addressData: {},
    };
  }

  async componentDidMount() {
    const { BusinessPartner } = this.props.auth;
    await this.props.loadCustomerMasterData();
    const filterStr = `BusinessPartner eq '${BusinessPartner}' and BPCustomerNumber eq '${BusinessPartner}'`;
    await this.props.getShipToPartyData(this.props.enqueueSnackbar, filterStr);
    this.updatePickerData();
  }

  updatePickerData = () => {
    try {
      const { checkout, auth } = this.props;
      const { shipToPartyDataArr } = checkout;
      const { selectedSalesOrgData, customerMasterData } = auth;
      const { Division, SalesOrg, DisCha } = selectedSalesOrgData;

      let addressData =
        shipToPartyDataArr.length > 0 ? shipToPartyDataArr[0] : { BusinessPartnerName: '' };
      addressData = { ...addressData, Division, SalesOrg, DisCha };

      if (customerMasterData && customerMasterData.length > 0) {
        const customerData = customerMasterData[0];
        const mappedFields = {
          CreditSegment: customerData.CreditSegment,
          CreditBlock: customerData.CreditBlock ? 'Yes' : 'No',
          CreditLimit: `${customerData.CreditLimit} ${customerData.Currency}`,
          AvailableCredit: `${customerData.AvailableCredit} ${customerData.Currency}`,
        };
        addressData = { ...addressData, ...mappedFields };
      }

      if (shipToPartyDataArr.length > 0 || SalesOrg !== undefined) {
        this.setState({
          addressData,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  signOut = async () => {
    try {
      const msalInstance = this.props.msalContext.instance;
      await msalInstance.logoutPopup();
      this.props.logUserOut();
      this.props.handleSalesOrgDialog(true);
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    const { t } = this.props;
    const { addressData } = this.state;

    return (
      <Container>
        <Breadcrumbs {...this.props} breadcrumbNameMap={breadcrumbNameMap(t)} />
        <Grid container direction="row" justifyContent="center" sx={{ marginY: 6 }}>
          <Grid
            item
            container
            direction="row"
            justifyContent="space-between"
            xs={12}
            sm={12}
            md={4}
            sx={{ paddingX: { xs: 0, sm: 0, md: 2 }, mb: 2 }}
          >
            <Grid
              sx={{
                flex: 1,
                border: `1px solid ${COLOR.borderColor}`,
                height: 'fit-content',
              }}
            >
              <Box
                sx={{
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: 120,
                  backgroundPosition: 'center',
                  backgroundColor: COLOR.bgColor,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                }}
              />
              <Grid
                container
                direction="row"
                justifyContent="space-around"
                sx={{
                  paddingY: 0,
                  paddingX: 2.25,
                  mt: -3.75,
                  pb: 2.5,
                }}
                alignItems="center"
                textAlign="center"
              >
                <Grid item xs={12} sm={12} md={12} lg={4}>
                  <Avatar
                    sx={{
                      bgcolor: deepPurple[500],
                      width: 100,
                      height: 100,
                      border: `5px solid ${COLOR.whiteTextColor}`,
                    }}
                  >
                    {getAvatarText(addressData.BusinessPartnerName)}
                  </Avatar>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={8}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontSize: 20,
                      pt: { xs: 0, sm: 2, md: 2 },
                      pl: { xs: 0, sm: 2, md: 2 },
                      mt: { xs: 0, sm: 2, md: 2 },
                    }}
                  >
                    {addressData.BusinessPartnerName}
                  </Typography>
                </Grid>
              </Grid>
              <Divider />
              <Grid sx={{ mt: 1, mb: 1 }}>
                <Typography
                  variant="subtitle2"
                  onClick={this.signOut}
                  sx={{
                    backgroundColor: 'transparent',
                    alignItems: 'center',
                    paddingY: 0.75,
                    paddingX: 2,
                    fontSize: 14,
                    mb: 0,
                    cursor: 'pointer',
                    color: COLOR.blackColor,
                    '&:hover': {
                      color: COLOR.linkColor2,
                    },
                  }}
                >
                  {t('profileScreenTranslations:SIGN_OUT')}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={8} sx={{ paddingX: { xs: 0, sm: 0, md: 2 }, mb: 5 }}>
            {Info(this.props.t).map((i, index) => {
              return (
                <Grid key={index.toString()}>
                  <Typography
                    sx={{
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      textTransform: 'uppercase',
                      color: COLOR.helperTextColor,
                      letterSpacing: '.025rem',
                      mb: 1.5,
                      mt: index !== 0 ? 6 : 0,
                    }}
                  >
                    {i.title}
                  </Typography>
                  <Divider sx={{ mb: 3 }} />

                  <Grid item container direction="row" justifyContent="space-between" xs={12}>
                    {i.data.map((d, dIndex) => {
                      return (
                        <Grid
                          item
                          container
                          direction="row"
                          justifyContent="space-between"
                          key={dIndex.toString()}
                          xs={12}
                          sm={5}
                          md={5}
                          sx={{ mb: 2.5 }}
                        >
                          <Typography variant="subtitle1" fontSize="sm">
                            {d.label}:
                          </Typography>
                          <Typography variant="subtitle1" fontSize="sm" color="#696969">
                            {addressData[d.value]}
                          </Typography>
                          {/* <OutlinedInput
                            placeholder=""
                            value={addressData[d.value]}
                            fontSize="sm"
                            readOnly
                          /> */}
                        </Grid>
                      );
                    })}
                  </Grid>
                  <Grid />
                </Grid>
              );
            })}

            {/* <Divider sx={{ mb: 3 }} />
            <Stack direction="row" justifyContent="flex-end">
              <Button
                variant="contained"
                color="primary"
                sx={{
                  fontSize: { xs: 10, sm: 14, md: 14 },
                  paddingY: 0,
                  paddingX: 2.75,
                  height: 46,
                }}
              >
                {t('profileScreenTranslations:UPDATE_PROFILE')}
              </Button>
            </Stack> */}
          </Grid>
        </Grid>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    checkout: state.checkout,
  };
};
const cProfile = connect(mapStateToProps, {
  logUserOut,
  handleSalesOrgDialog,
  loadCustomerMasterData,
  getShipToPartyData,
})(Profile);
const tProfile = withTranslation(['profileScreenTranslations'])(cProfile);
const msProfile = withMsal(tProfile);
const sProfile = withSnackbar(msProfile);

export { sProfile as Profile };
